// src/composables/useFilterPage.js
// 頁面從第一畫面切換到第二畫面
import { computed } from 'vue'
import { useStore } from 'vuex'
export default function useFilterPage () {
  const store = useStore()
  const filteredPageData = computed(() => {
    // sidebar渲染，根據第一畫面選擇，篩選對應的列表給回傳v-for
    return store.state.linkpage[store.state.nowPage.charCodeAt() - 65].content
  })
  return {
    filteredPageData
  }
}
